import { useCallback, useEffect, useMemo, useState } from "react";

const useTableConfig = (collapse: boolean) => {
  const rowCount = useMemo(() => (collapse ? 5 : 10), [collapse]);
  const [fontSize, setFontSize] = useState<"small" | "large">("small");

  const resizeFont = useCallback(() => {
    if (window.innerWidth > 1500) {
      setFontSize("large");
    } else setFontSize("small");
  }, []);

  useEffect(() => {
    resizeFont();
    window.addEventListener("resize", () => resizeFont());
    return window.removeEventListener("resize", () => resizeFont());
  }, [resizeFont]);

  return { rowCount, fontSize };
};

export default useTableConfig;
